import { render, staticRenderFns } from "./OffList.vue?vue&type=template&id=5445f03c&scoped=true&"
import script from "./OffList.vue?vue&type=script&lang=js&"
export * from "./OffList.vue?vue&type=script&lang=js&"
import style0 from "./OffList.vue?vue&type=style&index=0&id=5445f03c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5445f03c",
  null
  
)

export default component.exports